import { styled } from '@mui/material/styles'

const getStyles = (theme) => (
  {
    root: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginRight: 16
    }
  }
)
const PREFIX = 'UnitFooterStyles'
const classes = {}
const classNames = Object.keys(getStyles({}))

classNames.forEach(key => {
  classes[key] = `${PREFIX}-${key}`
})

const UnitFooterStyles = styled('div')(({ theme }) => {
  const styles = getStyles(theme)
  const myClass = {}
  classNames.forEach(key => {
    const className = key === 'root' ? `&.${classes.root}` : `& .${classes[key]}`
    myClass[className] = {
      ...styles[key]
    }
  })
  return (myClass)
})

export {
  classes,
  UnitFooterStyles
}
